import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/containers/Events/MediaIndustryLeaders/index.tsx");
